/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type SoftwareTimelineEntrypointComponent = EntryPointComponent<{}, {}, {}, {}>;

export const softwareTimelineEntrypoint: EntryPoint<SoftwareTimelineEntrypointComponent, {}> =
	createEntryPoint({
		root: JSResourceForUserVisible<SoftwareTimelineEntrypointComponent>(
			/* webpackChunkName: "async-software-timeline-entrypoint" */ './NextGenExportedDefault.tsx',
			{
				entryFsSsrLiftImportToModule: true,
			},
		),
		getPreloadProps: () => ({}),
	});
